




















import { Component, Vue } from 'vue-property-decorator';
import { ContentLoader } from '@tencent/wphk-components-content-loader';
@Component({
  components: {
    ContentLoader,
  },
})
export default class HomeContentLoader extends Vue {
}
